import { useMemo } from "react";
import { useSelector } from "react-redux";

import MiniCart from "components/cart/MiniCart/MiniCart";
import Button from "components/common/ui/Button/Button";
import IconWishlist from "components/common/ui/Icons/IconWishlist/IconWishlist";
import Link from "components/common/ui/Link/Link";
import UserModal from "components/UserModal/UserModal";
import styled from "styled-components";

import { useTranslation } from "react-i18next";
import { Breakpoint } from "ts/enums";
import PathTranslationKey from "utilities/paths";
import { remCalc } from "utilities/styles";
import { dark } from "utilities/variables/colors";
import { Roboto } from "utilities/variables/fonts";
import { aboveMedium } from "utilities/variables/media";

import { ReactComponent as ExchangeIcon } from "../../../assets/images/svg/ExchangeIcon.svg";
import SearchModal from "components/common/ui/SearchModal/SearchModal";

const StyledDiv = styled.div`
	display: flex;
	flex-grow: 1;
	justify-content: flex-end;

	.material-symbols-outlined {
		font-size: 32px;
	}

	.currency {
		position: absolute;
		right: ${remCalc(28)};
		bottom: ${remCalc(-14)};
		color: ${dark};
		font-family: ${Roboto};
		font-size: ${remCalc(12)};
		letter-spacing: ${remCalc(0.5)};
		display: flex;
		align-items: center;

		@media screen and (min-width: 480px) {
			position: unset;
			margin: auto 0;
		}

		svg {
			height: ${remCalc(17)};
			width: ${remCalc(15)};
			margin-right: ${remCalc(5)};
			transform: scaleX(-1);
		}
	}

	ul {
		display: inline;
		padding: 0;
		margin: auto 0;

		@media ${aboveMedium} {
			display: flex;
		}

		li {
			margin: 0 4px;
			display: inline-flex;
			justify-content: center;
			align-items: center;

			@media screen and (max-width: ${Breakpoint.LARGE}px) {
				margin: 0;
			}

			button.btn-icon-only {
				svg {
					scale: 0.75;

					@media ${aboveMedium} {
						scale: 0.9;
					}
				}
			}
		}
	}

	.currency__active {
		font-weight: 700;
	}
`;

const StyledLink = styled(Link)`
	display: flex;
`;

const WishlistButton = () => {
	const { t } = useTranslation();

	return (
		<StyledLink to={`${t(PathTranslationKey.ACCOUNT_WISHLIST)}`}>
			<Button icon={<IconWishlist />} />
		</StyledLink>
	);
};

const NavUser = () => {
	return (
		<StyledDiv>
			<ul className="nav-buttons">
				<li>
					<SearchModal />
				</li>
				<li>
					<WishlistButton />
				</li>
				<li>
					<UserModal />
				</li>
				<li>
					<MiniCart />
				</li>
			</ul>
		</StyledDiv>
	);
};

export default NavUser;
